<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addDeopt"
          >新增仓库</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="keyWords"
          placeholder="输入仓库名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-cascader
          clearable
          style="marginRight:10px"
          ref="cascader"
          v-model="departId"
          :props="props"
          :show-all-levels="false"
          size="small"
          placeholder="请选择机构"
        ></el-cascader>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <el-table
      :data="depotList.records"
      stripe
      border
      lazy
      style="width: 100%"
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="编号"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        prop="depotCode"
        label="仓库编号"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="depotName"
        label="仓库名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="depotAddress"
        label="仓库地址"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="departName"
        label="所属机构"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="shopList"
        label="关联商店"
        width="280"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.shopList.length">
            <span v-for="(v, i) in scope.row.shopList" :key="i" class="shop">{{
              v.shopName
            }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip class="item" content="编辑" placement="top">
              <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="depotList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="仓库编号" prop="depotCode">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleForm.depotCode"
            maxlength="20"
            size="small"
            placeholder="请输入仓库编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="仓库名称" prop="depotName">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleForm.depotName"
            maxlength="20"
            size="small"
            placeholder="请输入仓库名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属机构" prop="deptList">
          <el-cascader
            ref="cascader"
            v-model="ruleForm.deptList"
            :props="props"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="关联商店" prop="shopList">
          <el-select
            v-model="ruleForm.shopList"
            value-key="shopId"
            filterable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in storeList"
              :key="i"
              :label="item.shopName"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="depotAddress">
          <el-input
            clearable
            v-model="ruleForm.depotAddress"
            maxlength="20"
            size="small"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="context">
          <el-input
            clearable
            type="number"
            v-model="ruleForm.context"
            maxlength="20"
            size="small"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>

        <el-form-item label="默认仓库" prop="isDefaultDepot">
          <template>
            <el-radio v-model="ruleForm.isDefaultDepot" label="yes"
              >是</el-radio
            >
            <el-radio v-model="ruleForm.isDefaultDepot" label="no">否</el-radio>
          </template>
        </el-form-item>
      </el-form>

      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  data() {
    // const patternLocation = function(rule, val, callback) {
    //   let haveEmptyCondition = false;

    //   const reg = /^[0-9a-zA-Z]+$/;
    //   if (!reg.test(val)) {
    //     haveEmptyCondition = true;
    //   }
    //   if (haveEmptyCondition) {
    //     return callback(
    //       new Error("编号为唯一值，仅支持英文和数字，不支持其他符号")
    //     );
    //   }
    //   callback();
    // }.bind(this);
    return {
      disabled: false,
      departId: [],
      options: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.id;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.id;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      dialogVisible: false,
      storeList: [],
      result: "",
      title: "",
      id: "",
      keyWords: "",
      pageSize: 10,
      currentPage: 1,
      ruleForm: {
        depotCode: "",
        depotId: "",
        depotName: "",
        deptList: [],
        shopList: [],
        isDefaultDepot: "",
        depotAddress: "",
        context: ""
      },
      rules: {
        depotCode: [
          {
            required: true,
            trrger: "blur",
            message: "请输入仓库编号"
          }
          // {
          //   required: true,
          //   validator: patternLocation,
          //   trigger: "blur"
          // }
        ],
        depotName: {
          required: true,
          trrger: "blur",
          message: "请输入仓库名称"
        },
        deptList: {
          required: true,
          message: "请选择机构"
        },
        shopList: {
          required: true,
          message: "请选择商店"
        },
        isDefaultDepot: {
          required: true,
          trrger: "blur",
          message: "请选择是否默认仓库"
        }
      }
    };
  },
  computed: mapGetters(["depotList"]),
  watch: {},
  created() {
    this.getParamsCookie();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      this.setParamsCookie();
      if (this.departId) {
        this.departId = this.departId[this.departId.length - 1];
      }
      this.$store.dispatch("queryDepotListList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        queryKey: this.keyWords,
        departId: this.departId
      });
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        departId: this.departId
      };
      setCookie({
        key: "depotListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "depotListParams", type: "session" });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.departId = prams.departId;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    edit(row) {
      this.storeList = [];
      this.title = "编辑仓库信息";
      const params = {
        depotId: row.depotId
      };
      if (row.syncFlag !== "hemiao") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      this.dialogVisible = true;
      this.$store
        .dispatch("queryShopList", { pageSize: 9999, currentPage: 1 })
        .then(res => {
          const result = res.result || {};
          if (res.code == 0) {
            this.storeList = result.records;
          }
        });
      this.$store.dispatch("queryByIdDepot", params).then(res => {
        const result = res.result || {};
        if (res.code == 0) {
          for (let key in result) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = result[key];
              setTimeout(() => {
                if (this.$refs.cascader) {
                  if (result.deptList) {
                    this.$refs.cascader.presentText =
                      result.deptList[0].departName;
                  }
                }
              }, 0);
            }
          }
          if (result.deptList) {
            this.ruleForm.deptList = [result.deptList[0].id || ""];
          }
        }
      });
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          // let params = this.ruleForm;
          params.deptList = [
            {
              id: params.deptList[params.deptList.length - 1]
            }
          ];
          this.$store
            .dispatch(
              this.title === "新增仓库" ? "addDepot" : "editDepot",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisible = false;
                this.queryList();
                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
              }
            });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    addDeopt() {
      this.title = "新增仓库";
      this.disabled = false;
      this.dialogVisible = true;
      this.$store
        .dispatch("queryShopList", { pageSize: 9999, currentPage: 1 })
        .then(res => {
          const result = res.result || {};
          if (res.code == 0) {
            this.storeList = result.records;
          }
        });
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.shop {
  margin-left: 5px;
}
</style>
